module.exports = __webpack_public_path__ + "static/media/loader.8a698f09.gif";